import { render, staticRenderFns } from "./PageMeasurements.vue?vue&type=template&id=cbf3760e&scoped=true"
import script from "./PageMeasurements.vue?vue&type=script&lang=js"
export * from "./PageMeasurements.vue?vue&type=script&lang=js"
import style0 from "./PageMeasurements.vue?vue&type=style&index=0&id=cbf3760e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf3760e",
  null
  
)

export default component.exports